module.exports = __webpack_public_path__ + "img/bell.4c48e2ba.svg";